import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_roles',
};

export const getRolesRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
